




























































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { AxiosError } from 'axios';

import { ALForm } from '@/common/component.types';

import { ITag, ITagData, Tag, TagFieldError } from '@/models';

// components
import ErrorAlert from '../common/ErrorAlert.vue';
import { diffDeep } from '@/utils/helpers';
import { ErrorManager } from '@/models/error';
import AlDialog from '@/components/core/Dialog/ALDialog.vue';

export interface Options extends InstanceType<typeof Vue> {
  $refs: {
    form: ALForm;
  };
}

export default Vue.extend<Options>({
  functional: false
}).extend({
  name: 'ItemTagFormDialog',

  components: {
    ErrorAlert,
    AlDialog
  },

  data() {
    return {
      dialog: false,
      tagFormValid: false,
      isEdit: false,

      loading: false,

      errorMessage: '',
      detailErrorMessage: '',

      fieldError: new TagFieldError(),

      tag: {} as ITagData,

      requiredRule: [(v: string) => !!v || 'Name is required']
    };
  },

  computed: {
    ...mapGetters({
      getTagById: 'itemTag/getTagById'
    })
  },

  methods: {
    ...mapActions({
      createTag: 'itemTag/createTag',
      updateTag: 'itemTag/updateTag'
    }),

    resetFormValidation(): void {
      if (this.$refs.form) {
        return this.$refs.form.resetValidation();
      }
    },

    validateForm(): boolean {
      let valid = false;
      if (this.$refs.form) {
        valid = this.$refs.form.validate();
      }
      return valid;
    },

    open(tag?: ITag) {
      if (tag) {
        this.tag = new Tag(tag);
      } else {
        this.tag = {
          name: ''
        };
      }

      this.isEdit = !!tag;
      this.clearAllErrors();
      this.dialog = true;

      this.resetFormValidation();
    },

    clearAllErrors(): void {
      this.fieldError.clearErrors();
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    close() {
      this.dialog = false;
    },

    async saveTag(): Promise<void> {
      if (this.validateForm()) {
        this.clearAllErrors();

        this.loading = true;

        try {
          if (this.isEdit) {
            const tagDelta = diffDeep(
              this.tag,
              this.getTagById(this.tag.id),
              true
            );

            await this.updateTag(tagDelta).then(() => {
              this.$emit('update:tag');
            });
          } else {
            await this.createTag(this.tag).then(() => {
              this.$emit('create:tag');
            });
          }

          this.loading = false;
          this.dialog = false;
        } catch (err) {
          this.loading = false;
          const error = err as AxiosError;
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
            // client received an error response that falls out of range 2xx
            if (TagFieldError.isTagFieldError(error.response.data)) {
              this.fieldError = new TagFieldError(error.response.data);
            }
          }

          this.errorMessage = ErrorManager.extractApiError(error);
        }
      }
    }
  }
});
